import React from 'react';
import { compose, withState, defaultProps } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';

import { Offline, Online } from 'op/components/offline';
import { withLocale } from 'op/components/locale';

const StpFormSubmitModal = ({ locale, validation, validate, openModal, setOpenModal, onSubmit, onSave, online  }) => {
    const [isValidationError, setIsValidationError] = React.useState(false);
    const [isValidating, setIsValidating] = React.useState(false);
    return (
        <Modal
            trigger={
                <Button
                    type='button'
                    primary
                    disabled={!validation.ok}
                    onClick={() => {
                        setIsValidating(true);
                        validate().then((isValid) => {
                            setOpenModal(true);
                            if (!isValid) {
                                setIsValidationError(true);
                            }
                        }).finally(() => {
                            setIsValidating(false);
                        });
                    }}
                    loading={isValidating}
                >
                    {locale.saveOrSend}
                </Button>
            }
            open={openModal}
            onClose={() => setOpenModal(false)}
            basic
        >
            <Header icon={isValidationError ? 'warning sign' : 'th list'} content={isValidationError ? locale.theSTPTestHasFailed : locale.header} />
            <Modal.Actions>
                <Button basic onClick={() => setOpenModal(false)} color='red' inverted floated='left'>
                    <Icon name='remove' /> {locale._system.cancel}
                </Button>
                <Online>
                    <Button
                        type='submit'
                        onClick={() => {
                            onSubmit();
                            setOpenModal(false);
                        }} color={isValidationError ? 'yellow' : 'green'} inverted>
                        <Icon name='checkmark' /> {locale._system.save}
                    </Button>
                </Online>
                <Offline>
                    <Button onClick={() => {
                        onSave();
                        setOpenModal(false);
                    }} color='blue' inverted>
                        <Icon name='checkmark' /> {locale._system.save}
                    </Button>
                </Offline>
            </Modal.Actions>
        </Modal>);
};

export default compose(
    withLocale('stp.submit'),
    withState('openModal', 'setOpenModal', false),
    defaultProps({
        onSave: () => {
        },
        onSubmit: () => {
        },
    }),
    hot(module),
)(StpFormSubmitModal);
